import { MASK, HASH, DENY } from './policyEffectStrings'

export const POLICY_EFFECT_STRING_ENUM = {
  [MASK]: 'mask',
  [HASH]: 'hash',
  [DENY]: 'deny',
}
